import api from '@/utils/api'
import STATUS from '@/utils/status'
import _ from 'lodash'

const state = {
  contacts: null,
  status: STATUS.IDLE
}

let originalState = _.cloneDeep(state)

const mutations = {
  setContacts (state, contacts) {
    state.contacts = contacts
  }
}

const actions = {
  load (ctx) {
    return new Promise((resolve, reject) => {
      if (ctx.state.contacts) {
        return resolve()
      }
      ctx.state.status = STATUS.LOADING
      return api.get('contacts').then((response) => {
        ctx.commit('setContacts', response.data.contacts)
        ctx.state.status = STATUS.LOADED
        resolve()
      }).catch(() => {
        ctx.state.status = STATUS.ERROR
      })
    })
  },
  clean ({state}) {
    for (let attr in originalState) {
      state[attr] = originalState[attr]
    }
  }
}

const getters = {
  contacts (state) {
    return state.contacts || []
  },
  status (state) {
    return state.status
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/contacts.js